export const CONTACT = {
  phoneDisplay: "+351 961 308 405",
  phoneHref: "tel:+351961308405",
  whatsapp: "https://wa.me/351961308405",
  email: "cebolafishiguide26@gmail.com",
  instagram: "https://instagram.com/cebola_fishinguide",
  facebook: "https://facebook.com/cebolafishinguide",
};

export const GALLERY = [
  "/images/lucio-perca.jpg",
  "/images/barbo.jpg",
  "/images/gallery-3.jpg",
  "/images/gallery-4.jpg",
  "/images/gallery-5.jpg",
  "/images/gallery-6.jpg",
  "/images/gallery-7.jpg",
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1662912879826-249a9a87cdd8?fm=jpg&q=85&w=2400&auto=format&fit=crop&ixlib=rb-4.1.0",
  about: "https://images.unsplash.com/photo-1568295374184-57cfa8ca4599?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxmaXNoaW5nJTIwc3Vuc2V0JTIwbGFrZXxlbnwwfHx8fDE3ODU0MTEwMDN8MA&ixlib=rb-4.1.0&q=85",
  achiga: "/images/achiga.jpg",
  lucioReal: "/images/lucio-real.jpg",
  barbo: "/images/barbo.jpg",
  lucioPerca: "/images/lucio-perca.jpg",
};
